import { AGENT_BY_ID } from '../config/competition'
import { clock, compactMoney, price as fmtPrice, signedCompactMoney } from '../core/format'
import type { Trade } from '../core/types'
import { AgentAvatar, TokenIcon } from './primitives/Media'
import { Panel } from './primitives/Panel'
import { Standby } from './primitives/Standby'

const ACTION_TONE: Record<string, string> = { BUY: 'up', SELL: 'down', CLOSE: 'neutral' }

export function TradeTape({ trades, standby }: { trades: Trade[]; standby: boolean }) {
  if (standby) {
    return (
      <Panel title="TAPE / FILLS" flush>
        <Standby note="Every execution, newest first." />
      </Panel>
    )
  }

  const feed = [...trades].reverse().slice(0, 60)
  return (
    <Panel
      title="TAPE / FILLS"
      note={<span className="u-num">{trades.length} THIS ROUND</span>}
      scroll
      flush
      className="tape"
    >
      {feed.length === 0 ? (
        <p className="empty">No fills yet.</p>
      ) : (
        <ul className="tapelist">
          {feed.map((t, i) => {
            const a = AGENT_BY_ID[t.agentId]
            return (
              <li
                key={t.id}
                className={`fill ${i === 0 ? 'is-fresh' : ''}`}
                style={{ ['--accent' as string]: a?.color }}
                title={`${a?.name ?? t.agentId} · ${t.action} ${t.symbol} @ ${fmtPrice(t.price)} · ${compactMoney(t.notional)} on ${t.venue}
${t.txHash}`}
              >
                <span className="fill__time u-num">{clock(t.ts)}</span>
                <AgentAvatar agentId={t.agentId} size={14} />
                <span className={`fill__act fill__act--${ACTION_TONE[t.action]}`}>{t.action}</span>
                <span className="fill__sym">
                  <TokenIcon symbol={t.symbol} size={14} />
                  {t.symbol}
                </span>
                <span className="fill__px u-num">@{fmtPrice(t.price)}</span>
                {t.pnl === null ? (
                  <span className="fill__pnl u-flat">--</span>
                ) : (
                  <span className={`fill__pnl u-num ${t.pnl >= 0 ? 'u-up' : 'u-down'}`}>
                    {signedCompactMoney(t.pnl)}
                  </span>
                )}
              </li>
            )
          })}
        </ul>
      )}
    </Panel>
  )
}
